module.exports = __webpack_public_path__ + "static/media/favicon-chubb.11c45658.ico";